import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			dark: {
				appTheme: '#222933', //37474F dark blue - 1976D2 blue
			},
			light: {
				appTheme: '#222933', //37474F dark blue - 1976D2 blue
				cardHeaderTheme: '#F0F3F5', //F0F3F5, e7eef0
				contentTheme: '#E4E5E6'
			},
		},
	},
	breakpoint: {
		thresholds: {
			xs: 350,
			sm: 600,
			md: 900,
			lg: 1280,
		},
		scrollBarWidth: 24,
	},
});
